const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
const UPDATE_UID = 'UPDATE_UID'
const UPDATE_THEME = 'UPDATE_THEME'
const UPDATE_FONTSIZE = 'UPDATE_FONTSIZE'
const UPDATE_TITLE_MAP = 'UPDATE_TITLE_MAP'
const UPDATE_DELTA_HEIGHT = 'UPDATE_DELTA_HEIGHT'
export {
  UPDATE_USER_INFO,
  UPDATE_UID,
  UPDATE_THEME,
  UPDATE_FONTSIZE,
  UPDATE_TITLE_MAP,
  UPDATE_DELTA_HEIGHT
}



// WEBPACK FOOTER //
// ./src/store/mutation-type.js